(function () {
  'use strict';

  angular.module('eclipseApp.liveChat').config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('liveChat', {
        url: '/live-chat',
        parent: 'app',
        params :{
          accountNumber : '',
          ctn : '',
        },
        title: "liveChat",
        views: {
          content: {
            templateUrl: 'modules/live-chat/views/live-chat.html',
            controller: 'liveChatCtrl'
          }
        }
      });
  }]);

})();
